import baseAxios from '@/api/base';

baseAxios.defaults.baseURL = `${process.env.VUE_APP_APIPATH}`;

/** EssayPapers api */

/**
 * 取得學生已購買的套裝列表（包含試卷）
 * @param {object} data {
  "pageIndex": 0,
  "pageSize": 0,
  "data": {
    "courseName": "string"
  }
}
 */
export const GetStudentPurchasedCoursesList = (data) => baseAxios.post('/FrontEnd/EssayPapers/GetStudentPurchasedCoursesList', data);

/**
 * 取得學生指定套裝下的試卷列表
 * @param {object} data {
  "pageIndex": 0,
  "pageSize": 0,
  "data": {
    "courseId": 0,
    "essayPapersName": "string"
  }
}
 */
export const GetStudentEssayPapersList = (data) => baseAxios.post('/FrontEnd/EssayPapers/GetStudentEssayPapersList', data);

/**
 * 取得學生試卷詳細資料（主試卷資料、題目資料、批改資料）
 * @param {object} data {
  "essayPapersId": 0,
  "courseId": 0
}
 */
export const GetStudentEssayPaperDetail = (data) => baseAxios.post('/FrontEnd/EssayPapers/GetStudentEssayPaperDetail', data);

/**
 * 學生儲存單題答案
 * @param {object} data {
  "essayPapersId": 0,
  "courseId": 0,
  "essayQuestionsId": 0,
  "answerContent": "string",
  "markerType": 0,
  "currentDurationSeconds": 0
}
 */
export const SaveStudentEssayAnswer = function SaveStudentEssayAnswer(data, showLoading = false) {
  baseAxios.defaults.showLoading = showLoading;
  return baseAxios.post('FrontEnd/EssayPapers/SaveStudentEssayAnswer', data);
};

/**
 * 學生確認交卷
 * @param {object} data {
  "essayPapersId": 0,
  "courseId": 0
}
 */
export const SubmitStudentEssayPaper = (data) => baseAxios.post('/FrontEnd/EssayPapers/SubmitStudentEssayPaper', data);

/**
 * 取得學生標記狀態
 * @param {object} data {
  "type": 0
}
 */
export const GetEssayMarkerType = (data) => baseAxios.post('/FrontEnd/EssayPapers/GetEssayMarkerType', data);
